module.exports = __webpack_public_path__ + "img/08-表格.c42fb1c7.png";